module.exports = __webpack_public_path__ + "images/referenzen/werbespot/tesa_tvc_powerstrips_transparen_small.jpg";